export default __webpack_public_path__ + "static/media/sql.069b8e3a.jpg";